class RentaForm {
  constructor (prefix = '.c-rentaForm') {
    this.prefix = prefix
    this.currentStep = 1
    this.totalSteps = 8
    this.formData = {}
    this.init()
  }

  init () {
    const forms = document.querySelectorAll(this.prefix)

    forms.forEach((formEl) => {
      if (formEl.offsetParent === null) return
      this.setupForm(formEl)
    })
  }

  setupForm (formEl) {
    const form = formEl.querySelector('form')
    const steps = form.querySelectorAll('.c-rentaForm__step')
    const progressBar = form.querySelector('#progress-bar')
    const progressText = form.querySelector('#progress-text')
    const progressDots = form.querySelectorAll('.step-dot')
    const submitButton = form.querySelector('#submit-final')

    // Mostrar primer paso
    this.showStep(1, steps, progressBar, progressText, progressDots)

    // Event listeners para navegación
    form.querySelectorAll('.c-rentaForm__button-next').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const nextStep = parseInt(btn.dataset.next)
        if (this.validateStep(this.currentStep, form)) {
          this.saveStepData(this.currentStep, form)
          this.currentStep = nextStep
          this.showStep(this.currentStep, steps, progressBar, progressText, progressDots)
        }
      })
    })

    form.querySelectorAll('.c-rentaForm__button-prev').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const prevStep = parseInt(btn.dataset.prev)
        this.currentStep = prevStep
        this.showStep(this.currentStep, steps, progressBar, progressText, progressDots)
      })
    })

    // Envío final del formulario
    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.handleSubmit(form)
      })
    }

    // Validación en tiempo real
    form.querySelectorAll('input, select, textarea').forEach(input => {
      input.addEventListener('blur', () => {
        this.validateField(input)
      })

      // Para checkboxes
      if (input.type === 'checkbox') {
        input.addEventListener('change', () => {
          this.validateField(input)
        })
      }
    })

    // Manejo de archivos
    const fileInput = form.querySelector('#file_upload')
    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        const files = e.target.files
        const maxSize = 5 * 1024 * 1024 // 5MB
        let valid = true

        for (const file of files) {
          if (file.size > maxSize) {
            alert(`El archivo ${file.name} supera el tamaño máximo de 5MB`) // eslint-disable-line
            valid = false
            break
          }
        }

        if (!valid) {
          fileInput.value = ''
        }
      })
    }
  }

  showStep (step, steps, progressBar, progressText, progressDots) {
    // Ocultar todos los pasos
    steps.forEach(stepEl => {
      stepEl.style.display = 'none'
    })

    // Mostrar el paso actual
    const currentStepEl = Array.from(steps).find(el => parseInt(el.dataset.step) === step)
    if (currentStepEl) {
      currentStepEl.style.display = 'block'
    }

    // Actualizar barra de progreso
    const progress = (step / this.totalSteps) * 100
    if (progressBar) {
      progressBar.style.width = `${progress}%`
    }
    if (progressText) {
      progressText.textContent = `Paso ${step} de ${this.totalSteps}`
    }

    // Actualizar dots de progreso
    if (progressDots) {
      progressDots.forEach(dot => {
        const dotStep = parseInt(dot.dataset.step)
        dot.classList.remove('active', 'completed')
        if (dotStep === step) {
          dot.classList.add('active')
        } else if (dotStep < step) {
          dot.classList.add('completed')
        }
      })
    }
  }

  validateStep (step, form) {
    const currentStepEl = form.querySelector(`.c-rentaForm__step[data-step="${step}"]`)
    const inputs = currentStepEl.querySelectorAll('input[required], select[required], textarea[required]')
    let isValid = true

    inputs.forEach(input => {
      if (!this.validateField(input)) {
        isValid = false
      }
    })

    // Validación específica para checkbox de confirmación en paso 8
    if (step === 8) {
      const truthCheckbox = form.querySelector('#confirmation_truth')
      const privacyCheckbox = form.querySelector('#confirmation_privacy')

      if (truthCheckbox && !truthCheckbox.checked) {
        this.showError('Debes confirmar que los datos son veraces')
        truthCheckbox.closest('.c-rentaForm__checkbox').classList.add('has-error')
        isValid = false
      }

      if (privacyCheckbox && !privacyCheckbox.checked) {
        this.showError('Debes aceptar la política de privacidad')
        privacyCheckbox.closest('.c-rentaForm__checkbox').classList.add('has-error')
        isValid = false
      }
    }

    return isValid
  }

  validateField (input) {
    const errorClass = 'has-error'
    const parent = input.closest('.c-rentaForm__element, .c-rentaForm__checkbox')

    // Remover error anterior
    if (parent) {
      parent.classList.remove(errorClass)
      const errorMsg = parent.querySelector('.error-message')
      if (errorMsg) errorMsg.remove()
    }

    // Validación para checkbox
    if (input.type === 'checkbox' && input.hasAttribute('required')) {
      if (!input.checked && input.closest('.c-rentaForm__step[data-step="8"]')) {
        this.addError(parent, 'Este campo es obligatorio')
        return false
      }
      return true
    }

    if (input.hasAttribute('required') && !input.value.trim()) {
      this.addError(parent, 'Este campo es obligatorio')
      return false
    }

    // Validación de DNI
    if (input.id === 'dni' && input.value) {
      const dniRegex = /^[0-9]{8}[A-Z]$/
      if (!dniRegex.test(input.value.toUpperCase())) {
        this.addError(parent, 'DNI inválido. Formato: 12345678A')
        return false
      }
    }

    // Validación de email
    if (input.type === 'email' && input.value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(input.value)) {
        this.addError(parent, 'Introduce un email válido')
        return false
      }
    }

    // Validación de código postal
    if (input.id === 'zip' && input.value) {
      const zipRegex = /^[0-9]{5}$/
      if (!zipRegex.test(input.value)) {
        this.addError(parent, 'El código postal debe tener 5 dígitos')
        return false
      }
    }

    // Validación de IBAN
    if (input.id === 'iban' && input.value) {
      const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/
      if (!ibanRegex.test(input.value.toUpperCase())) {
        this.addError(parent, 'IBAN inválido. Formato: ES00 0000 0000 0000 0000 0000')
        return false
      }
    }

    return true
  }

  addError (parent, message) {
    if (parent) {
      parent.classList.add('has-error')
      const errorMsg = document.createElement('span')
      errorMsg.className = 'error-message'
      errorMsg.textContent = message
      parent.appendChild(errorMsg)
    }
  }

  showError (message) {
    const errorContainer = document.querySelector('#error-message')
    if (errorContainer) {
      errorContainer.textContent = message
      errorContainer.classList.remove('isHidden')
      setTimeout(() => {
        errorContainer.classList.add('isHidden')
      }, 5000)
    }
  }

  saveStepData (step, form) {
    const currentStepEl = form.querySelector(`.c-rentaForm__step[data-step="${step}"]`)
    const inputs = currentStepEl.querySelectorAll('input, select, textarea')

    inputs.forEach(input => {
      if (input.name) {
        if (input.type === 'checkbox') {
          this.formData[input.name] = input.checked ? 'si' : ''
        } else if (input.type === 'file') {
          // Los archivos se manejan por separado
          if (input.files.length > 0) {
            this.formData[input.name] = 'Archivos adjuntos: ' + Array.from(input.files).map(f => f.name).join(', ')
          }
        } else {
          this.formData[input.name] = input.value
        }
      }
    })
  }

  handleSubmit (form) {
    if (!this.validateStep(8, form)) {
      return
    }

    // Guardar datos del último paso
    this.saveStepData(8, form)

    // Obtener token de reCAPTCHA
    const tokenInput = form.querySelector('#recaptcha-token')

    // Verificar si reCAPTCHA está disponible y hay clave
    if (typeof grecaptcha !== 'undefined' && tokenInput && window.recaptchaSiteKey) {
      grecaptcha.ready(() => { // eslint-disable-line
        grecaptcha.execute(window.recaptchaSiteKey, { action: 'submit' }) // eslint-disable-line
          .then(token => {
            tokenInput.value = token
            this.sendForm(form)
          })
          .catch(() => {
          // Si falla reCAPTCHA, enviar igualmente
            this.sendForm(form)
          })
      })
    } else {
      this.sendForm(form)
    }
  }

  sendForm (form) {
    // Mostrar loading
    const loading = form.querySelector('#loading-spinner')
    const submitBtn = form.querySelector('#submit-final')
    if (loading) loading.classList.remove('isHidden')
    if (submitBtn) submitBtn.disabled = true

    // Preparar datos para enviar
    const formData = new FormData() // eslint-disable-line
    formData.append('action', 'send_renta_form')
    formData.append('nonce', form.querySelector('#nonce').value)

    // Añadir todos los datos guardados
    for (const [key, value] of Object.entries(this.formData)) {
      formData.append(key, value)
    }

    // Añadir archivos
    const fileInput = form.querySelector('#file_upload')
    if (fileInput && fileInput.files.length > 0) {
      for (const file of fileInput.files) {
        formData.append('files[]', file)
      }
    }

    // Añadir token de recaptcha
    const tokenInput = form.querySelector('#recaptcha-token')
    if (tokenInput) {
      formData.append('token', tokenInput.value)
    }

    // Añadir datos de página
    formData.append('formFromUrl', form.querySelector('input[name="formFromUrl"]').value)
    formData.append('pageName', form.querySelector('input[name="pageName"]').value)
    formData.append('form_id', form.querySelector('input[name="form_id"]').value)

    // Enviar vía AJAX
    fetch('/wp-admin/admin-ajax.php', { // eslint-disable-line
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (loading) loading.classList.add('isHidden')
        if (submitBtn) submitBtn.disabled = false

        if (data.success) {
        // Mostrar mensaje de éxito
          const success = form.querySelector('#success-message')
          if (success) {
            success.classList.remove('isHidden')
          }
          form.querySelectorAll('.c-rentaForm__step').forEach(step => {
            step.style.display = 'none'
          })
          // Ocultar progreso
          const progress = form.querySelector('.c-rentaForm__progress')
          if (progress) progress.style.display = 'none'

          // Reiniciar nonce
          const newNonce = form.querySelector('#nonce')
          if (data.new_nonce && newNonce) {
            newNonce.value = data.new_nonce
          }
        } else {
          const error = form.querySelector('#error-message')
          if (error) {
            error.textContent = data.error || 'Error al enviar el formulario'
            error.classList.remove('isHidden')
          }
        }
      })
      .catch(() => {
        if (loading) loading.classList.add('isHidden')
        if (submitBtn) submitBtn.disabled = false

        const errorEl = form.querySelector('#error-message')
        if (errorEl) {
          errorEl.textContent = 'Error de conexión. Inténtalo de nuevo.'
          errorEl.classList.remove('isHidden')
        }
      })
  }
}

export default RentaForm
